export default "__VITE_ASSET__D75MOp7Y__"